<template>
  <v-card class="com-mb-card">
    <v-col class="com-mb-card-contents">
      <v-row>
        <v-slider
          v-model="opacity"
          :label="text.sliderLavel"
          max="100"
          min="0"
          hide-details="auto"
          step="10"
          always-dirty
          :thumb-size="24"
          class="px-2"
        ></v-slider>
      </v-row>
    </v-col>
  </v-card>
</template>
<script>
export default {
  name: "iu-opacity",
  data() {
    return {
      /** 透過率 */
      opacity: null,
      /** 文字列リソース */
      text: {
        sliderLavel: "透過率",
      },
    };
  },
  created() {
    /** 初期透過率取得 */
    this.opacity = this.$store.state.inundation.inundationOpacity;
  },
  watch: {
    /** 透過率設定 */
    opacity() {
      this.$store.commit("inundation/setInundationOpacity", this.opacity);
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
